import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useUpgradePlanPromotion = (enabled = true) => {
  const query = useQuery({
    queryKey: [QueryKeys.UPGRADE_PLAN_PROMOTION],
    queryFn: accountRepo.getUpgradePlanPromotion,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled,
  });

  return useQueryMemoized(query);
};

export type UseUpgradePlanPromotion = ReturnType<typeof useUpgradePlanPromotion>;
